import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { HttpService, UtilityService } from 'services';
import { PATTERN } from 'utils/constants';

@Component({
  templateUrl: './complete-profile.component.html',
})
export class CompleteProfileComponent implements OnInit {
  profileForm: FormGroup;
  currentPassword: FormControl;
  password: FormControl;
  confirmPassword: FormControl;
  constructor(
    public dialogRef: MatDialogRef<CompleteProfileComponent>,
    private http: HttpService, private fb: FormBuilder,
    private util: UtilityService) {
    this.profileForm = this.fb.group({
      firstName: new FormControl(null, Validators.required),
      lastName: new FormControl(null, Validators.required),
      email: new FormControl(null, [Validators.required, Validators.pattern(PATTERN.EMAIL)]),
      phone: new FormControl(null, [Validators.required, Validators.pattern(PATTERN.MOBILE)]),
    });
  }

  ngOnInit() { }

  onSubmit() {
    if (this.profileForm.valid) {
      const data = { ...this.profileForm.value };
      // this.http.changePassword(data).subscribe(
      //   res => {
      //     if (res.ok) {
      //       this.util.showMsg('Profile Updated', 'Successfully');
      //       this.dialogRef.close();
      //     }
      //   },
      //   err => { this.http.errorMessage(err); }
      // );
    } else {
      console.log('FormData is Invalid');
    }
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
}
